var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-coupon" }, [
    _c(
      "div",
      { staticClass: "add-coupon__title" },
      [
        _vm.isVivaincontri
          ? _c("svg-add-coupon-vivaincontri")
          : _c("div", { staticClass: "coupon-icon coupon-empty" }),
        _vm._v(" "),
        _c("div", { staticClass: "text-lg" }, [
          _vm._v(_vm._s(_vm.trans.title)),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "add-coupon__input" }, [
      _c("div", { staticClass: "w-full" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.coupon_code,
              expression: "coupon_code",
            },
          ],
          staticClass: "form-control",
          class: _vm.error ? "is-invalid" : "",
          attrs: {
            maxlength: "10",
            type: "text",
            placeholder: _vm.trans.placeholder,
            name: "coupon-code-input",
          },
          domProps: { value: _vm.coupon_code },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.coupon_code = $event.target.value
              },
              function ($event) {
                _vm.coupon_code = _vm.coupon_code.replace(/\s/g, "")
              },
            ],
          },
        }),
        _vm._v(" "),
        _vm.error
          ? _c("div", { staticClass: "invalid-feedback" }, [
              _vm._v(_vm._s(_vm.error)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("ui-button", {
            attrs: {
              "button-type": "outline",
              appearance: "secondary",
              uppercase: "",
              "font-weight": "bold",
              label: _vm.trans.apply,
              disabled: !_vm.coupon_code,
            },
            on: { click: _vm.add_coupon },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.showAllCouponsLink
      ? _c(
          "a",
          {
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.all_coupons_show.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm.trans.view_all))]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "couponLinkedModal",
        staticClass: "modal fade",
        attrs: {
          id: "couponLinkedModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "couponLinkedModal",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-sm",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                { staticClass: "modal-header bg-transparent border-0" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "close font-weight-light outline-none",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                      },
                      on: { click: _vm.close },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body pt-0" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.couponLoaded,
                        expression: "couponLoaded",
                      },
                    ],
                    staticClass: "flex-column",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center d-flex flex-column" },
                      [
                        _c("i", {
                          staticClass:
                            "fa fa-check-circle text-4xl text-green-600",
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-1" }),
                        _vm._v(" "),
                        _c("div", [
                          _c("h6", { staticClass: "mb-0 text-lg" }, [
                            _vm._v(_vm._s(_vm.trans.coupon_generated)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.canBeUsedImmediately,
                                  expression: "!canBeUsedImmediately",
                                },
                              ],
                              staticClass: "text-base",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.trans.can_use_it_when_promoting)
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "coupon rounded-lg d-flex flex-column h-100 coupon-border py-3 px-4",
                      },
                      [
                        _c("div", { staticClass: "flex-grow" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "coupon-header d-flex flex-column xs-flex-row",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mx-auto xs-mx-0 my-auto" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "coupon-subtitle text-blue-600 text-lg sm-text-xl lg-text-2xl leading-4 pt-1 pt-sm-0",
                                    },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "text-blue-600 font-weight-light text-base sm-text-lg lg-text-xl m-0 d-block mb-0 md-mb-1",
                                        },
                                        [_vm._v(_vm._s(_vm.coupon.type_title))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "text-blue-600 font-weight-bold text-lg sm-text-xl lg-text-2xl m-0 d-inline leading-6",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.coupon.title) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isCttProduct
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "font-weight-bold text-lg sm-text-xl lg-text-2xl text-pink-600 text-sm sm-text-base lg-text-lg",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.coupon.product.value)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "coupon-description pt-1 pt-sm-0 text-sm",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-light" },
                                        [_vm._v(_vm._s(_vm.coupon.description))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.canBeUsedImmediately,
                            expression: "!canBeUsedImmediately",
                          },
                        ],
                        staticClass:
                          "btn btn-primary waves-effect rounded-xl w-100",
                        attrs: { type: "button", "data-dismiss": "modal" },
                      },
                      [_vm._v(_vm._s(_vm.trans.close))]
                    ),
                    _vm._v(" "),
                    _c("use-coupon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.canBeUsedImmediately,
                          expression: "canBeUsedImmediately",
                        },
                      ],
                      attrs: {
                        "url-use-coupon": _vm.urlUseCoupon,
                        w100: "",
                        "data-dismiss": "modal",
                        id: _vm.coupon.id,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "allCouponsModal",
        staticClass: "modal fade",
        attrs: {
          id: "allCouponsModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "imgTopLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog  modal-dialog-centered  modal-lg",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h6",
                  {
                    staticClass: "modal-title text-center text-2xl",
                    attrs: { id: "your-coupons-modalLabel" },
                  },
                  [_vm._v(_vm._s(_vm.trans.your_coupons))]
                ),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("div", { staticClass: "mt-3 mb-4" }, [
                    _c("h6", { staticClass: "font-weight-bold" }, [
                      _vm._v(
                        _vm._s(_vm.trans.your_coupons_with_nearest_expiration)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("coupons-list", {
                    attrs: {
                      "url-use-coupon": _vm.urlUseCoupon,
                      coupons: _vm.coupons,
                      "is-vivaincontri": _vm.isVivaincontri,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "ui-button",
                        {
                          attrs: {
                            href: _vm.urlCouponsPage,
                            "button-type": "blank",
                            appearance: "secondary",
                            uppercase: "",
                            "font-weight": "bold",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.trans.view_all) +
                              "\n                      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close font-weight-light outline-none",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }